import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'error-unauthorized',
  templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent implements OnInit {

  @Input() public title?: string;
  @Input() public description?: string;

  constructor() { }

  ngOnInit(): void {
  }

}
